import { render, staticRenderFns } from "./TestWaterMark.vue?vue&type=template&id=3e1ef631&scoped=true"
import script from "./TestWaterMark.vue?vue&type=script&lang=js"
export * from "./TestWaterMark.vue?vue&type=script&lang=js"
import style0 from "./TestWaterMark.vue?vue&type=style&index=0&id=3e1ef631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1ef631",
  null
  
)

export default component.exports